// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Tabs-module--cds--assistive-text--YBBLx";
export var cdsVisuallyHidden = "Tabs-module--cds--visually-hidden--waWr2";
export var dropdownWrapper = "Tabs-module--dropdownWrapper--ift6i";
export var hideFeedback = "Tabs-module--hide-feedback--+N9UV";
export var panel = "Tabs-module--panel--RIs9h";
export var showFeedback = "Tabs-module--show-feedback--aROv9";
export var skeleton = "Tabs-module--skeleton--kcfYg";
export var tab = "Tabs-module--tab--tr3HV";
export var tabList = "Tabs-module--tab-list--OOWlk";